export function cutString(string, length) {
if (string.length > length) {
    return string.slice(0, length) + '...'
  }
  return string
}

export function setAcronym(str) {
  if (!str) return ''
    const nameArray = str.split(' ')
    return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
}

export function shortenStringIfTooLong(string, maxChars, charWidth) {
  const screenWidth = window.innerWidth;
  // if (screenWidth < 540) {
    const maxCharsToShow = Math.floor(screenWidth / charWidth) - 3; // Subtract 3 to account for ellipsis
    if (string.substring(0, maxCharsToShow).length < string.length) {
      return cutString(string.substring(0, maxCharsToShow), maxChars) + '...';
    }
    return cutString(string, maxChars)
  // }
  // return string;
}
export function getFormattedDateForBackend(date) {
  date = new Date(date)
  const d = date.getDate()
  const m = date.getMonth() + 1
  const y = date.getFullYear()
  return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d
}
